// 导入请求数据的 request 模块
import request from '@/utils/request'

// 根据分类查询资讯信息
export const SelectSign = (label, currentPage, pageSize) => {
  return request.get('/sign/select', {
    params: {
      label: label,
      currentPage: currentPage,
      pageSize: pageSize
    }
  })
}
